export const randomPercents = () => {
    const first = Math.round(Math.random() * 100);
    const second = Math.round(Math.random() * (100 - first));
    return [first, second, 100 - first - second];
};
